import { motion, AnimatePresence } from 'framer-motion';
import { X, Mic, MicOff } from 'lucide-react';
import { CALL } from '@/constants/testIds';
import { useLanguage } from '../context/LanguageContext';

export const ParticipantSidebar = ({ open, onClose, participants, isMobile = false }) => {
  const { t } = useLanguage();
  return (
  <AnimatePresence>
    {open && (
      <>
        {isMobile && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
            className="fixed inset-0 z-30 bg-black/40"
          />
        )}
        <motion.aside
          data-testid={CALL.sidebar}
          initial={isMobile ? { y: '100%', opacity: 0 } : { x: '100%', opacity: 0 }}
          animate={isMobile ? { y: 0, opacity: 1 } : { x: 0, opacity: 1 }}
          exit={isMobile ? { y: '100%', opacity: 0 } : { x: '100%', opacity: 0 }}
          transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          className={
            isMobile
              ? 'fixed inset-x-0 bottom-0 z-40 flex max-h-[75vh] flex-col rounded-t-3xl border-t border-slate-200 bg-white shadow-2xl'
              : 'absolute right-0 top-0 z-20 flex h-full w-80 flex-col border-l border-slate-200 bg-white/95 backdrop-blur-xl'
          }
        >
          {isMobile && <div className="mx-auto mt-3 h-1 w-10 shrink-0 rounded-full bg-slate-200" />}
          <div className="flex items-center justify-between px-5 py-5">
            <h3 className="font-heading text-lg font-semibold text-slate-900">{t('call.participantsTitle', participants.length)}</h3>
            <button
              data-testid={CALL.sidebarCloseBtn}
              onClick={onClose}
              aria-label={t('call.closeParticipants')}
              className="rounded-full p-2 text-slate-500 transition-colors hover:bg-slate-100 hover:text-slate-900"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto px-3 pb-4">
            {participants.map((p) => (
              <div
                key={p.userId}
                data-testid={CALL.sidebarItem(p.userId)}
                className="flex items-center justify-between gap-3 rounded-xl px-3 py-3 transition-colors hover:bg-slate-50"
              >
                <div className="flex items-center gap-3">
                  <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#3B82F6]/10 text-sm font-semibold text-[#3B82F6]">
                    {(p.name || '?').trim().charAt(0).toUpperCase()}
                  </div>
                  <span className="truncate font-body text-sm text-slate-900">
                    {p.name}
                    {p.isLocal ? t('call.you') : ''}
                  </span>
                </div>
                {p.hasAudio ? (
                  <Mic className="h-4 w-4 shrink-0 text-emerald-400" />
                ) : (
                  <MicOff className="h-4 w-4 shrink-0 text-red-400" />
                )}
              </div>
            ))}
          </div>
        </motion.aside>
      </>
    )}
  </AnimatePresence>
  );
};
